import * as React from "react";
import type { SVGProps } from "react";
const SvgStarHalfFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 1.99c-.78 0-1.44.47-1.69 1.2L8.44 8.62H3.79c-.81 0-1.5.51-1.72 1.27-.22.75.08 1.54.74 1.97l4.01 2.6-1.79 5.21c-.25.74-.01 1.51.62 1.98a1.8 1.8 0 0 0 2.13 0L12 18.58V1.99Z"
    />
  </svg>
);
export default SvgStarHalfFilled;
